export default __webpack_public_path__ + "static/media/icon-dropdown-dark.5358406b.svg";